// @flow
export default function addZendeskScriptElement() {
  // @Reviewer: I don't know if this is a reliable way to add the script tag only once.
  const documentBody = document.body;
  if (documentBody && !window.zESettings) {
    window.zESettings = {
      webWidget: {
        color: {
          theme: '#555555',
        },
      },
    };

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.async = true;
    script.src =
      'https://static.zdassets.com/ekr/snippet.js?key=e48e8904-9f48-42e7-8c6e-a2079ffc2478';
    documentBody.appendChild(script);
  }
}
